<div class="attendance-page">
  <h1 class="page-title">Attendance</h1>
  <p class="page-sub">Pick a class and date, load the roster, mark statuses, then save.</p>

  <mat-card class="filters-card">
    <mat-card-content>
      <form [formGroup]="form" class="filters-row">
        <mat-form-field appearance="outline" class="field-class">
          <mat-label>Class</mat-label>
          <mat-select formControlName="className" required>
            <mat-option *ngFor="let c of classOptions" [value]="c">{{ c }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="field-date">
          <mat-label>Date</mat-label>
          <input matInput [matDatepicker]="picker" formControlName="attendanceDate" />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <div class="filter-actions">
          <button mat-flat-button color="primary" type="button" (click)="loadRoster()" [disabled]="form.invalid || loadingRoster">
            Load roster
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>

  <div *ngIf="loadingRoster" class="loading-row">
    <mat-spinner diameter="36"></mat-spinner>
    <span>Loading roster…</span>
  </div>

  <mat-card *ngIf="rosterLoaded" class="table-card">
    <mat-card-actions align="end" class="table-toolbar">
      <button mat-stroked-button type="button" (click)="markAllPresent()">Mark all present</button>
      <button mat-flat-button color="primary" type="button" (click)="save()" [disabled]="!dataSource.data.length || saving">
        {{ saving ? 'Saving…' : 'Save attendance' }}
      </button>
    </mat-card-actions>
    <mat-card-content>
      <table mat-table [dataSource]="dataSource" class="roster-table">
        <ng-container matColumnDef="rollNumber">
          <th mat-header-cell *matHeaderCellDef>Roll</th>
          <td mat-cell *matCellDef="let row">{{ row.rollNumber || '—' }}</td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Student</th>
          <td mat-cell *matCellDef="let row">{{ row.firstName }} {{ row.lastName }}</td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let row">
            <mat-form-field appearance="outline" class="status-field">
              <mat-label>Mark</mat-label>
              <mat-select
                [value]="statusSelectValue(row)"
                (selectionChange)="updateRowStatus(row, $event.value === '' ? null : $event.value)"
              >
                <mat-option value="">Not set</mat-option>
                <mat-option *ngFor="let opt of statusOptions" [value]="opt.value">{{ opt.label }}</mat-option>
              </mat-select>
            </mat-form-field>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns; trackBy: trackByStudentId"></tr>
      </table>
      <p *ngIf="!dataSource.data.length" class="empty-hint">No rows. Load roster after students exist for this class.</p>
    </mat-card-content>
  </mat-card>
</div>
